import React, { Fragment, useState, useEffect } from 'react'
import {Nav, Navbar, Row, Col} from 'react-bootstrap'
import Seccion from './Seccion'
import Scrollspy from 'react-scrollspy'
  
function Header() {

  const [ruta, setRuta] = useState('')

  const [blueC, setBlueC] = useState(false)
  const [blackC, setBlackC] = useState(false)

  useEffect(() => {
    setRuta(window.location.pathname)
  }, []);

  useEffect(() => {
    console.log(ruta);
    if(ruta === "/we"){
      document.getElementById("twe").classList.add("blue")
    } else if(ruta === "/users"){
      document.getElementById("tusers").classList.add("blue")
    } else if(ruta === "/company"){
      document.getElementById("tcompany").classList.add("blue")
    }
  }, [ruta]);
  
  const getSeccion = (e) => {
    if(e !== undefined){
      console.log("ONUPDATE",e.id)
      let currentID = e.id;
      let haynegro = false
      let listaBlack = ["dicio-about","dicio-team", "users-about", "users-appContainer", "business_success_stories", "contact"]
      listaBlack.forEach(element => {
          if(element === currentID){
            console.log("es negro");
            haynegro=true
          }
        }
      );
      if(haynegro){
        document.getElementById("menuN").classList.add("menuNavW")
        document.getElementById("socialButton").style.backgroundColor = "#161616"
        document.getElementById("cambImg").innerHTML = '<img src="./img/logo_light.svg" alt="" style= "max-width:140px; width:100%;" id="cambImg" className="imgLogo"/>'
        document.getElementById("cambImg").style.backgroundColor ="#161616"
      }else{
        document.getElementById("menuN").classList.remove("menuNavW")
        document.getElementById("cambImg").innerHTML = '<img src="./img/logo-4ac.svg" alt="" style= "max-width:140px; width:100%;" id="cambImg" className="imgLogo"/>'
        document.getElementById("socialButton").style.backgroundColor = "white"
        document.getElementById("cambImg").style.backgroundColor = "white"

      }
      if (currentID === "contact"){
        document.getElementById("cambImg").innerHTML = '<img src="./img/logo-4ac.svg" alt="" style= "max-width:140px; width:100%;" id="cambImg" className="imgLogo"/>'
        document.getElementById("cambImg").style.backgroundColor = "white"
        document.getElementById("socialButton").style.backgroundColor = "white"
      }
    }
  }

    return (
      <Fragment>
        <header className="topFixed" id="head-container">
            <Row style={{height:"100px"}}>
              <Col xs={6} md={8} style={{height:"100px"}}>
                <Row>
                  <Col xs={12} md={3} id="logoImg" style={{maxWidth:"180px"}}>
                    <a className="navbar-brand" href="index" id="cambImg">
                      <img src="./img/logo-4ac.svg" alt="" style={{maxWidth:"140px", width:"100%"}} id="cambImg" className="imgLogo"/>
                    </a>
                  </Col>
                  <Col xs={12} md={8} >
                    <div className="social-button hide show-inline middle" id="socialButton">
                      <div className="dis-inline-block middle ">
                        <p className=" fs-12 fw-bold c-blue txt-uppercase letter-spacing-3px">
                          Follow us
                        </p>
                      </div>
                      <div className="dis-inline-block middle margenF">
                        <a href="https://twitter.com/Dicio_AI" target="_blank" className="dis-inline-block middle pad-all-5">
                          <i className="fab fa-twitter"></i>
                        </a>

                        <a href="https://www.facebook.com/Dicioai/" target="_blank" className="dis-inline-block middle pad-all-5">
                          <i className="fab fa-facebook-f"></i>
                        </a>

                        
                        <a href="https://www.linkedin.com/company/dicio-ai/about/" target="_blank" className="dis-inline-block middle pad-all-5">
                          <i className="fab fa-linkedin-in"></i>
                        </a>

                        <a href="https://www.instagram.com/dicio.ai/" target="_blank" className="dis-inline-block middle pad-all-5">
                          <i className="fab fa-instagram"></i>
                        </a>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Col>
              <Col xs={6} md={4}>
                <Navbar expand="lg" className="fullW flex-column align-items-end custom-toggler">
                  <Navbar.Toggle aria-controls="basic-navbar-nav" style={{border:"0"}} className="c-black"/>
                  <Navbar.Collapse id="basic-navbar-nav" >
                  <Nav id="menuN" defaultActiveKey="/index" className="menuNav fullW flex-column align-items-end" style={{padding:"0"}}>
                    <Nav.Link href="/we" id="twe" >WE</Nav.Link>
                    <Scrollspy items={ ['dicio-about', 'dicio-business', 'dicio-team', 'contact'] } currentClassName="is-current" className={(ruta === "/we") ? "siVisible": "noVisible"} onUpdate={e=>getSeccion(e)}>
                        <li id="mwe1"><Nav.Link href="#dicio-about" >What is DICIO?</Nav.Link></li>
                        <li id="mwe2"><Nav.Link href="#dicio-business">Our alies</Nav.Link></li>
                        <li id="mwe3"><Nav.Link href="#dicio-team" >Team</Nav.Link></li>
                        <li id="mwe4"><Nav.Link href="#contact" >Contact</Nav.Link></li>
                    </Scrollspy>
                    <Nav.Link href="/users" id="tusers" >USERS</Nav.Link>
                      <Scrollspy items={ ['users-features', 'users-about', 'users-testimonial', 'users-appContainer', 'contact'] } currentClassName="is-current" className={(ruta === "/users") ? "siVisible": "noVisible"} onUpdate={e=>getSeccion(e)}>
                          <li id="musers1"><Nav.Link href="#users-features">Why use DICIO?</Nav.Link></li>
                          <li id="musers2"><Nav.Link href="#users-about" >How  it works?</Nav.Link></li>
                          <li id="musers3"><Nav.Link href="#users-testimonial">Testimonials</Nav.Link></li>
                          <li id="musers4"><Nav.Link href="#users-appContainer" >App</Nav.Link></li>
                          <li id="musers5"><Nav.Link href="#contact">Contact</Nav.Link></li>
                      </Scrollspy>
                    <Nav.Link href="/company" id="tcompany" >COMPANY</Nav.Link>
                      <Scrollspy items={ ['business_about', 'business_success_stories', 'contact'] } currentClassName="is-current" className={(ruta === "/company") ? "siVisible": "noVisible"} onUpdate={e=>getSeccion(e)}>
                        <li id="mcompany1"><Nav.Link href="#business_about" >Benefits of DICIO</Nav.Link></li>
                        <li id="mcompany2"><Nav.Link href="#business_success_stories"  >Success stories</Nav.Link></li>
                        <li id="mcompany3"><Nav.Link href="#contact" >Contact</Nav.Link></li>
                      </Scrollspy>
                  </Nav>
                </Navbar.Collapse>
              </Navbar>
              </Col>
            </Row>
          </header>
      </Fragment>
    );
}
export default Header;